import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ListChecks } from "lucide-react";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";
import { PriorityBadge, DueLabel } from "@/components/tasks/TaskBadges";

const Stat = ({ label, value, cls, to, testid }) => (
  <Link to={to} data-testid={testid} className="rounded-lg border border-slate-100 px-3 py-2 hover:border-primary/40 transition-colors">
    <div className={`text-xl font-head font-extrabold font-mono-tech ${cls}`}>{value}</div>
    <div className="text-[11px] text-slate-500">{label}</div>
  </Link>
);

export default function DashboardTasksCard() {
  const [d, setD] = useState(null);
  const [err, setErr] = useState(false);
  useEffect(() => { api.get("/tasks/summary").then((r) => setD(r.data)).catch(() => setErr(true)); }, []);
  const today = new Date().toLocaleDateString("sv-SE", { timeZone: "Europe/Berlin" });
  return (
    <Card className="p-5 fade-up" data-testid="dash-my-tasks">
      <div className="flex items-center justify-between mb-3">
        <h3 className="font-head font-bold text-lg flex items-center gap-2"><ListChecks className="h-5 w-5 text-primary" />Meine Aufgaben</h3>
        <Link to="/aufgaben" className="text-xs text-primary font-medium" data-testid="dash-my-tasks-all">Alle Aufgaben anzeigen →</Link>
      </div>
      {err && <p className="text-sm text-red-600">Aufgaben konnten nicht geladen werden.</p>}
      {!d && !err && <div className="h-24 bg-slate-100 rounded-lg animate-pulse" />}
      {d && (
        <>
          <div className="grid grid-cols-4 gap-2">
            <Stat label="Heute fällig" value={d.today} cls="text-amber-600" to="/aufgaben?cat=today" testid="dash-tasks-today" />
            <Stat label="Überfällig" value={d.overdue} cls={d.overdue ? "text-red-600" : "text-slate-900"} to="/aufgaben?cat=overdue" testid="dash-tasks-overdue" />
            <Stat label="Offen" value={d.open} cls="text-slate-900" to="/aufgaben?cat=open" testid="dash-tasks-open" />
            <Stat label="Kritisch" value={d.critical} cls={d.critical ? "text-red-600" : "text-slate-900"} to="/aufgaben?cat=open&priority=kritisch" testid="dash-tasks-critical" />
          </div>
          <div className="mt-3 divide-y divide-slate-100">
            {d.next.length === 0 && <p className="text-sm text-slate-400 py-2">Keine offenen Aufgaben – alles erledigt.</p>}
            {d.next.map((t) => (
              <Link key={t.key} to={`/aufgaben?open=${t.type}:${t.id}`} data-testid={`dash-task-${t.key}`} className="flex items-center gap-3 py-2 hover:bg-slate-50 -mx-2 px-2 rounded">
                <PriorityBadge p={t.priority} />
                <div className="flex-1 min-w-0"><div className="truncate text-sm text-slate-800">{t.title}</div><div className="text-[11px] text-slate-400 truncate">{[t.project_name, t.building, t.room].filter(Boolean).join(" · ")}</div></div>
                <DueLabel t={t} today={today} />
              </Link>
            ))}
          </div>
        </>
      )}
    </Card>
  );
}
